<template>
    <div>

        <div class="content-box" style="min-height: 100%;">

            <h3>Porträttsfoto</h3>
            <p>Ladda upp ett foto på dig själv.</p>

            <div class="presentation-upload-box" v-if="state === 'upload'">

                <h2 v-if="!loading">Släpp filen här</h2>
                <h2 v-if="loading">Laddar...</h2>
                <input type="file" id="file_input" @change="upload" style="z-index:1;" v-if="!loading" />

            </div>

            <div v-show="state === 'crop'">

                <cropper
                    class="cropper"
                    ref="cropper"
                    :src="cropUrl"
                    :stencil-props="{
                        aspectRatio: 1,
                        movable: true,
                        resizable: true,
                        handlers: {
                            eastNorth: true,
                            north: false,
                            westNorth: true,
                            west: false,
                            westSouth: true,
                            south: false,
                            eastSouth: true,
                            east: false,
                        }
                    }"
                    :resize-image="{
                        adjustStencil: false
                    }"
                    :min-height="300"
                    :min-width="300"
                    @change="change"
                    :debounce="false"
                    :resizeImage="false"
                />

                <h4>Förhandsvisning:</h4>

                <div class="preview-row">
                    <div>
                        <div class="presentation-preview-full">
                            <preview
                                :width="120"
                                :height="120"
                                :image="thumb"
                                :coordinates="coordinates"
                            />
                        </div>

                        <span class="explenation">Fönster</span>
                    </div>

                    <div>
                        <div class="presentation-preview-full">
                            <div class="overlay"></div>
                            <preview
                                :width="120"
                                :height="120"
                                :image="thumb"
                                :coordinates="coordinates"
                            />
                        </div>
                        <span class="explenation text-center">Karta</span>
                    </div>
                </div>

                <button class="btn btn-warning" @click="remove">Ta bort/byt foto</button>

            </div>

        </div>
    </div>
</template>

<script>

import { Cropper, Preview } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import axios from 'axios'

export default {

    components: {
        Cropper,
        Preview
    },

    props: {
        clinic_id: {
            required: true
        },
        portrait: {
            required: true
        }
    },

    data () {
        return {
            state: 'upload', // upload || crop
            loading: false,
            thumb: null,
            coordinates: {}
        }
    },

    mounted () {
        if (this.portrait) {
            this.edit()
        }
    },

    computed: {
        cropUrl () {
            if (this.portrait) {
                return '/storage/clinic-presentation/' + this.portrait.name + '.jpg'
            }

            return ''
        }
    },

    methods: {
        edit () {
            this.state = 'crop'

            this.$refs.cropper.setCoordinates({
                width: this.portrait.crop_width,
                height: this.portrait.crop_height,
                left: this.portrait.crop_left,
                top: this.portrait.crop_top
            })
        },

        change ({ coordinates, image, visibleArea, canvas }) {
            this.coordinates = coordinates
            this.thumb = image

            this.$emit('change', coordinates)
        },

        upload (event) {
            if (this.loading) {
                return
            }

            this.loading = true

            const files = event.target.files || event.dataTransfer.files
            if (!files.length) { return }

            const formData = new FormData()
            formData.append('file', files[0], files[0].name)
            formData.append('type', 'portrait')

            axios.post(
                '/clinics/' + this.clinic_id + '/presentation/upload',
                formData
            )
                .then(response => {
                    console.log('upload')
                    console.log(response.data)

                    this.$emit('upload', response.data)
                    this.state = 'crop'
                })
                .catch(error => {
                    alert('Sparing misslyckades, vänligen försök igen.')
                })
                .finally(() => {
                    this.loading = false
                })
        },

        remove () {
            if(confirm("Vill du verkligen ta bort bilden?"))
            {
                this.$emit('upload', null)
                this.state = 'upload'
            }
        }
    }

}
</script>
